<div class="container my-4 px-0 d-flex flex-column w-100">
    <div class="d-flex justify-content-between mb-3" *ngIf="isAdmin">
        <a [routerLink]="['/account/create']" class="btn btn-lg btn-uiowa-dark">
            <fa-icon [icon]="['fas', 'credit-card']"></fa-icon> Create New Merchant Account
        </a>
        <button type="button" class="btn btn-lg btn-uiowa-dark" (click)="openMerchantProfileModal()">
            <fa-icon [icon]="['fas', 'briefcase']"></fa-icon> Create New Merchant Profile
        </button>
        <button type="button" class="btn btn-lg btn-uiowa-dark" (click)="openAddMerchantAccessUsersModal()">
            <fa-icon [icon]="['fas', 'user-plus']"></fa-icon> Add New Merchant Access Users
        </button>
    </div>
    <div class="d-flex justify-content-between mb-3" *ngIf="!isAdmin && isPrimaryContact">
        <a [routerLink]="['/account/create']" class="btn btn-lg btn-uiowa-dark">
            <fa-icon [icon]="['fas', 'credit-card']"></fa-icon> Create New Merchant Account
        </a>
        <a class="btn btn-lg btn-uiowa-dark" href="mailto:treasury-creditcards@uiowa.edu?subject=Request New Merchant Profile&body=Please include the Merchant Profile Name, Default Primary Contact Hawkid, and the Merchant Access Users Hawkids (if applicable).">
            <fa-icon [icon]="['fas', 'briefcase']"></fa-icon> Create New Merchant Profile
        </a>
        <a class="btn btn-lg btn-uiowa-dark" href="mailto:treasury-creditcards@uiowa.edu?subject=Request New Merchant Access User&body=Please include the Merchant Profile Name and the Merchant Access Users Hawkids.">
            <fa-icon [icon]="['fas', 'user-plus']"></fa-icon> Add New Merchant Access Users
        </a>
    </div>
    <div class="d-flex justify-content-center mb-3" *ngIf="!isAdmin && !isPrimaryContact">
        <a [routerLink]="['/account/create']" class="btn btn-lg btn-uiowa-dark">
            <fa-icon [icon]="['fas', 'credit-card']"></fa-icon> Create New Merchant Account
        </a>
    </div>
    <app-merchant-account-list [merchantAccounts]="merchantAccounts" headingText="My Merchant Accounts" [isAdmin]="isAdmin"></app-merchant-account-list>
</div>
